import React from "react";
import { useTranslation } from "react-i18next";

interface LoadingScreenProps {
  message: string;
}

const Loader: React.FC<LoadingScreenProps> = ({ message }) => {
  const { t } = useTranslation();
  const isError = message !== "";

  return (
    <div className="loading">
      <div className="loading_img">
        {isError ? (
          <i className="fa fa-exclamation-triangle" />
        ) : (
          <>
            <div />
            <div />
            <div />
            <div />
            <div />
            <div />
            <div />
            <div />
            <div />
            <div />
            <div />
            <div />
          </>
        )}
      </div>
      {isError ? <h2>{t(message)}</h2> : <h2>{t("panel.common.loading")}</h2>}
    </div>
  );
};

export default Loader;
